import { render } from "./honoreeListingComponent.vue?vue&type=template&id=455d25f4"
import script from "./honoreeListingComponent.vue?vue&type=script&lang=js"
export * from "./honoreeListingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__